import React from 'react';
import {DialogContentStyled, DialogStyled, DialogTitleStyled} from "./modalComponent";
import {ModalIds, useModal} from "../../contexts/ModalContext";
import ClearIcon from "@mui/icons-material/Clear";
import {
    ButtonStyled,
    HrLine,
    VerticalDividerStyled
} from "../styledComponent/styledComponents";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import {useMediaQuery} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {useNavigate} from "react-router-dom";
import {useGetAvailablePlanQuery} from "../../features/provider/providerSlice"
import { useSelector } from 'react-redux';
import { useUser } from '../../features/user/userSlice';

const FacilityEditModal = () => {
    const {handleClose, modalId} = useModal()
    const matches = useMediaQuery('(min-width:200px) and (max-width:600px)');
    const navigate = useNavigate();
    const userApiStatus = useSelector(useUser);

    const {data: getAvailablePlan, isLoading, error} = useGetAvailablePlanQuery(null,{
        skip: userApiStatus?.data?.user?.status !== "safarmarket" // If the user's step is "safarmarket," the query will be executed
    })

    const handleRouting = () => {
        navigate('/facility-selection')

        handleClose()
    }
    return (
        <DialogStyled open={modalId === ModalIds.FACILITY_EDIT} onClose={handleClose}
                      minWidth={!matches ? "500px" : "330px"} minHeight={260}>
            <DialogTitleStyled>
                <Typography whiteSpace={"noWrap"} component={"span"} fontSize={{xs: 14, sm: 16}} color={'#242424'}
                            fontWeight={'bold'}>
                    انتخاب شما:
                </Typography>
                <Stack
                    width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"end"} gap={1}>
                    <ButtonStyled
                        onClick={handleRouting}
                        color={"info"}
                        fontSize={12}
                        sx={{
                            "&:hover": {
                                backgroundColor: "unset"
                            }
                        }}
                        startIcon={
                            <Stack direction={"row"} gap={1} ml={{sm: -6, md: -7, lg: -8}}>
                                <img src={'images/edit-icon.svg'} alt='edit-icon'/>
                                <Typography fontSize={{xs: 14, sm: 16}}>ویرایش</Typography>
                            </Stack>
                        }>
                    </ButtonStyled>
                    <VerticalDividerStyled/>
                    <IconButton size={"small"} sx={{ml: -1}} color={"fourth"} onClick={handleClose}>
                        <ClearIcon/>
                    </IconButton>
                </Stack>
            </DialogTitleStyled>
            <HrLine/>
            <DialogContentStyled>
                <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Typography fontSize={{xs: 14, sm: 16}} color={'#7A7A7A'}>
                        مبلغ تسهیلات:
                    </Typography>
                    <Typography fontSize={{xs: 16, sm: 18}} color={'#242424'} fontWeight={"500"}>
                        {parseInt(getAvailablePlan?.data?.info?.amount)?.toLocaleString()}
                        <Typography component={"span"} fontSize={12} color={'#242424'}> تومان</Typography>
                    </Typography>
                </Stack>
                <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Typography fontSize={{xs: 14, sm: 16}} color={'#7A7A7A'}>
                        تامین کننده:
                    </Typography>
                    <Typography fontSize={16} color={'#242424'} fontWeight={"500"}>
                        {getAvailablePlan?.data?.info?.name_fa}
                    </Typography>
                </Stack>
                <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Typography fontSize={{xs: 14, sm: 16}} color={'#7A7A7A'}>
                        مدت بازپرداخت:
                    </Typography>
                    <Typography fontSize={{xs: 16, sm: 18}} color={'#242424'} fontWeight={"500"}>
                        {getAvailablePlan?.data?.selected_plan?.due?.toLocaleString()}
                        <Typography component={"span"} fontSize={12} color={'#242424'}> ماهه</Typography>
                    </Typography>
                </Stack>
            </DialogContentStyled>
        </DialogStyled>
    );
};

export default FacilityEditModal;